import type { ReactNode } from 'react'

import { Typography } from '@/src/elements/text/Typography'

export const SettingsSectionTitle = ({ children }: { children: ReactNode }) => (
  <Typography bold heading="h2" size="lg" className="w-full pt-7">
    {children}
  </Typography>
)
